  <template>
<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve">
<path class="st0" d="M27,62c-4.9,0-9,4.1-9,9v156c0,4.9,4.1,9,9,9h246c4.9,0,9-4.1,9-9V71c0-4.9-4.1-9-9-9H27z M36.8,74h226.5
  L150,171L36.8,74z M30,84l116.1,99.5c2.3,2,5.6,2,7.9,0L270,84v140H30L30,84z"/>
</svg>
</template>

<script>
export default {
    name: 'IconMail',
}
</script>

<style lang="scss" scoped>
</style>